import axiosInstance from "../../../helpers/api";

export const getVideosByChapterID = (id) => {
  return axiosInstance.get(`/student/videos/${id}`);
};

export const getVideoByID = (id) => {
  return axiosInstance.get(`/student/videos/show/${id}`);
};

export const getOtp = (id) => {
  return axiosInstance.get(`/student/videos/otp/${id}`);
};
export const setOtpUserData = (body) => {
  return axiosInstance.post(
    `https://dev.vdocipher.com/api/videos/${body?.id}/otp`,
    body
  );
};
export const updateSeenCount = (body) => {
  return axiosInstance.post(`/student/user_videos/add_watched_time`, body);
};

export const createSeenCount = (body) => {
  return axiosInstance.post(`/student/user_videos`, body);
};
export const addVoucher = (body) => {
  return axiosInstance.post(`/student/video-vouchers/use`, body);
};
export const moreVideoViews = (body) => {
  return axiosInstance.post(`/student/video-requests/request`, body);
};

export const videoData = (body) => {
  return axiosInstance.post(`/student/user_videos/add_watched_time`, body);
};

export const setVideoSeenCount = (id) => {
  return axiosInstance.put(`/students/user_videos/set_play/${id}`);
};

export const getLiveVideo = () => {
  return axiosInstance.get(`/students/live_videos`);
};

export const setLiveVideoSeen = (id) => {
  return axiosInstance.post(`/students/live_videos`, {
    zoom_id: id,
  });
};
